// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile_section {
  position: relative;
}
@media (min-width: 768px) {
  .profile_section .mt-md-4 {
    margin-top: 1.8rem !important;
  }
}
.profile_section .card {
  position: relative;
  margin-bottom: 2rem;
}
.profile_section .card:last-child {
  margin-bottom: 0;
}
.profile_section .card .card-header {
  border-bottom: 1px solid #e3ebf6;
}
.profile_section .card .card-img-top {
  position: relative;
}
.profile_section .card .profile_block {
  display: block;
  text-align: center;
  position: relative;
}
.profile_section .card .profile_block .profile_img {
  width: 150px;
  height: 150px;
  margin: 0 auto;
}
.profile_section .card .profile_block .profile_img,
.profile_section .card .profile_block .file-text {
  position: relative;
}
.profile_section .card .profile_block .profile_img .upload_btn,
.profile_section .card .profile_block .file-text .upload_btn {
  text-align: center;
  cursor: pointer;
  position: absolute;
  right: 0;
  bottom: 30px;
  line-height: 35px;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: #0237ca;
}
.profile_section .card .profile_block .profile_img .upload_btn i,
.profile_section .card .profile_block .file-text .upload_btn i {
  color: #ffffff;
}
.profile_section .syllabus .second_group,
.profile_section .package .second_group {
  margin-top: -1px;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/Profile/_profile.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EAEI;IACI,6BAAA;EAAV;AACF;AAGI;EACI,kBAAA;EACA,mBAAA;AADR;AAGQ;EACI,gBAAA;AADZ;AAIQ;EACI,gCAAA;AAFZ;AAKQ;EACI,kBAAA;AAHZ;AAMQ;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;AAJZ;AAMY;EACI,YAAA;EACA,aAAA;EACA,cAAA;AAJhB;AAOY;;EAEI,kBAAA;AALhB;AAOgB;;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAJpB;AAMoB;;EACI,cAAA;AAHxB;AAYQ;;EACI,gBAAA;AATZ","sourcesContent":[".profile_section {\n    position: relative;\n\n    @media (min-width: 768px) {\n\n        .mt-md-4 {\n            margin-top: 1.8rem !important;\n        }\n    }\n\n    .card {\n        position: relative;\n        margin-bottom: 2rem;\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n\n        .card-header {\n            border-bottom: 1px solid #e3ebf6;\n        }\n\n        .card-img-top {\n            position: relative;\n        }\n\n        .profile_block {\n            display: block;\n            text-align: center;\n            position: relative;\n\n            .profile_img {\n                width: 150px;\n                height: 150px;\n                margin: 0 auto;\n            }\n\n            .profile_img,\n            .file-text {\n                position: relative;\n\n                .upload_btn {\n                    text-align: center;\n                    cursor: pointer;\n                    position: absolute;\n                    right: 0;\n                    bottom: 30px;\n                    line-height: 35px;\n                    width: 35px;\n                    height: 35px;\n                    border-radius: 50%;\n                    background: #0237ca;\n\n                    i {\n                        color: #ffffff;\n                    }\n                }\n            }\n        }\n    }\n\n    .syllabus,\n    .package {\n        .second_group {\n            margin-top: -1px;\n        }\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
